"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _polished = require("polished");

var _default = {
  columns: 12,
  width: (0, _polished.rem)('1440px'),
  gutters: {
    small: (0, _polished.rem)('4px'),
    medium: (0, _polished.rem)('8px'),
    large: (0, _polished.rem)('10px'),
    xlarge: (0, _polished.rem)('10px')
  },
  outerGutters: {
    small: (0, _polished.rem)('16px'),
    medium: (0, _polished.rem)('20px'),
    large: (0, _polished.rem)('24px'),
    xlarge: (0, _polished.rem)('40px')
  }
};
exports.default = _default;
//# sourceMappingURL=grid.js.map